module.exports = __webpack_public_path__ + "static/media/repeat.63f0f264.svg";